(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elaur-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elaur-slides'))customElements.define('elaur-slides',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const rail=this.querySelector('.eh-slides'),slides=[...rail.children],dots=[...this.querySelectorAll('.eh-dots button')];const current=()=>Math.round(rail.scrollLeft/rail.clientWidth);const show=i=>rail.scrollTo({left:((i+slides.length)%slides.length)*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.querySelector('.eh-next').addEventListener('click',()=>show(current()+1));this.querySelector('.eh-prev').addEventListener('click',()=>show(current()-1));dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));rail.addEventListener('scroll',()=>dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===current()))));}});

  } catch(e) { console.error(e); }
})();
})();
